import { Component, OnInit } from '@angular/core';
import { HeaderService } from './header.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { deleteCookie } from 'src/app/shared/helpers/cookie';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    isMenuCollapsed = true;
    isDashboard : boolean = true;
    isChecked: boolean;

    constructor(private headerService: HeaderService, private router: Router, private modalService: NgbModal) {}

    ngOnInit() {
        var check = this.router.url.match(/dashboard/g);
        if(check){
            this.isDashboard = true;
        } else{
            this.isDashboard = false;
        }
    }

    checkValue(event: any){
        if(event === "Self"){
            (window as any).open("https://self.chaka.ng", "_self");
        }
        console.log("Clicked", event)
    }

    logoutModal(content) {
        this.modalService.open(content, {backdropClass: 'light-blue-backdrop'});
      }

    logout(){
        localStorage.clear();
        // this.router.navigate(['/menu']);
        deleteCookie("accessToken");
        (window as any).open("https://self.chaka.ng/accounts", "_self");
    }
}
